import { Grid, Text } from '@simplywallst/ui-core';
import { Heading } from '@simplywallst/ui-core/next';

export const TableTitle = ({
  itemCount,
  title,
}: {
  itemCount: number;
  title: 'Watching' | 'Holdings';
}) => {
  return (
    <Grid templateColumns="auto 24px" gap="8px" alignItems="center">
      <Heading as="h2" className="font-bold">
        {title}
      </Heading>
      <Grid
        backgroundColor="phantom"
        width="24px"
        height="24px"
        placeContent="center"
        borderRadius="x12"
      >
        <Text typography="xSmallStrong" color="textSoft">
          {itemCount}
        </Text>
      </Grid>
    </Grid>
  );
};
